import Cookies from 'js-cookie';

// Copy from Trip-planner

interface CookieOptions {
    expires: number; // number of days when cookie will expire; if not defined cookie will be a session cookie
}

interface CookieLib {
    get(name: string): string | undefined;
    set(name: string, value: string, options?: CookieOptions): void;
}

class Cookie implements CookieLib {
    public get(key: string): string | undefined {
        return Cookies.get(key);
    }

    public set(key: string, value: string, options?: CookieOptions): string | undefined {
        return Cookies.set(key, value, options);
    }
}

export const cookie = new Cookie();
